export default __webpack_public_path__ + "static/media/dribbble.5b4039d0.svg";